import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=3df3de96&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&lang=js&"
export * from "./UserSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=3df3de96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3de96",
  null
  
)

export default component.exports